import { Checkbox } from '@/components/ui/checkbox'
import { Badge } from '@/components/ui/badge'
import { formatCurrency } from '@/lib/utils'
import type { PagoConSaldo } from '@/services/aplicacionesService'

interface SaldoAFavorBannerProps {
  pagosConSaldo: PagoConSaldo[]
  totalSaldoAFavor: number
  usarSaldoAFavor: boolean
  onUsarSaldoChange: (checked: boolean) => void
}

export function SaldoAFavorBanner({
  pagosConSaldo,
  totalSaldoAFavor,
  usarSaldoAFavor,
  onUsarSaldoChange,
}: SaldoAFavorBannerProps) {
  return (
    <div className="rounded-lg border border-green-200 dark:border-green-900 bg-green-50 dark:bg-green-950/30 p-4 space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Badge variant="secondary" className="bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300">
            Saldo a favor
          </Badge>
          <span className="font-bold text-green-700 dark:text-green-300">
            {formatCurrency(totalSaldoAFavor)}
          </span>
        </div>
      </div>
      <div className="text-xs text-muted-foreground space-y-1">
        {pagosConSaldo.map(p => (
          <div key={p.id} className="flex justify-between">
            <span>{p.concepto} ({p.fecha})</span>
            <span>{formatCurrency(p.saldo_a_favor)}</span>
          </div>
        ))}
      </div>
      <div className="flex items-center space-x-2 pt-1">
        <Checkbox
          id="usarSaldo"
          checked={usarSaldoAFavor}
          onCheckedChange={(checked) => onUsarSaldoChange(checked === true)}
        />
        <label
          htmlFor="usarSaldo"
          className="text-sm font-medium leading-none cursor-pointer"
        >
          Aplicar saldo a favor a las deudas seleccionadas
        </label>
      </div>
    </div>
  )
}
